import hotkeys from 'hotkeys-js';
export * from 'hotkeys-js';
export default hotkeys;

// 全局不做过滤，放到具体的业务处理函数中去
hotkeys.filter = function () {
    return true;
};

export const hotkeyMap = {
    // 编辑
    E: 'e,E',
    // 发布/更新
    COMMAND_ENTER: 'command+enter',
    CTRL_ENTER: 'ctrl+enter',
    // 保存自定义版本
    COMMAND_E: 'command+e',
    // 撤销
    COMMAND_Z: 'command+z',
    CTRL_Z: 'ctrl+z',
};
